import React, { FC } from 'react'
import styled from 'styled-components'

import { Progress } from '@ucheba/ui/components/Progress/desktop'

import { Divider } from '@ucheba/ui/components/Divider/desktop'

const LoaderWrapper = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 64px;

  svg {
    width: 60px;
    height: 60px;
  }
`

const LoaderForPages: FC = () => (
  <>
    <Divider />

    <LoaderWrapper>
      <Progress />
    </LoaderWrapper>
  </>
)

export default LoaderForPages
